import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Container from 'components/shared/Container';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import cx from 'classnames';
import { Button } from 'components/components/atoms';
import { PromoDisclaimerModal } from 'components/components/molecules';

const CopyText = styled.div`
  line-height: 1.063rem;
`;

const DisclaimerText = (component) => {
  const { text } = component.fields;
  const textAlignment =
    getFieldValue(component.fields, 'textAlignment') || 'center';
  const ctaText = getFieldValue(component.fields, 'ctaText');
  const ctaLink = getFieldValue(component.fields, 'ctaLink');
  const disclaimerPopUp =
    getFieldValue(component.fields, 'disclaimerPopUp') || null;
  const hasDisclaimerPopUp = !!String(disclaimerPopUp || '').trim();
  const [showDisclaimerPopUp, setShowDisclaimerPopUp] =
    useState(hasDisclaimerPopUp);
  const modalRef = useRef();

  useEffect(() => {
    setShowDisclaimerPopUp(hasDisclaimerPopUp);
  }, [hasDisclaimerPopUp, disclaimerPopUp]);

  return (
    <>
      <Container className='py-4'>
        <CopyText
          className={cx(
            'text-mattamy-blue font-graphie text-sm tracking-normal ',
            {
              'text-center': textAlignment && textAlignment !== 'left',
              'text-left': !textAlignment || textAlignment === 'left',
            },
          )}
        >
          <RichText tag='span' className='richtext' field={text} />
        </CopyText>
        {ctaLink && ctaText && (
          <div className='mt-4 md:mt-6 text-center'>
            <Button
              variant={'outlined'}
              color={'mattamy-blue'}
              textColor={'mattamy-blue'}
              href={ctaLink.href}
              target={ctaLink.target}
              linkWrapperDescription={ctaText}
            >
              {ctaText}
            </Button>
          </div>
        )}
      </Container>

      {hasDisclaimerPopUp && (
        <PromoDisclaimerModal
          isOpen={showDisclaimerPopUp}
          disclaimerText={disclaimerPopUp}
          modalRef={modalRef}
          onClose={() => setShowDisclaimerPopUp(false)}
        />
      )}
    </>
  );
};
export default DisclaimerText;
